import {
  Card,
  CardContent,
  CardTitle,
  Container,
  Grid,
  GridCol,
  GridRow,
  Text,
} from '@legalshield/adonis-ux-framework';
import React from 'react';

type ErrorCardProps = {
  message: string;
};
const ErrorCard: React.FC<ErrorCardProps> = ({ message }) => {
  return (
    <Grid>
      <GridRow>
        <GridCol>
          <Container>
            <Card>
              <CardContent padding={6}>
                <CardTitle>{string_table.ERROR_CARD_TITLE}</CardTitle>
                <Text text={message} />
              </CardContent>
            </Card>
          </Container>
        </GridCol>
      </GridRow>
    </Grid>
  );
};

export default ErrorCard;
